@if (attachmentCount() > 0) {
  <div class="view-attachments-cell-template">
    <button
      type="button"
      andButton
      color="ghost-secondary"
      size="small"
      dataSelector="view-attachments-button"
      (click)="onClick()"
    >
      <anduin-icon name="paperclip" class="me-1" fill="none" stroke="currentColor" />
      {{ label() }}
    </button>
  </div>
}
